module.exports = __webpack_public_path__ + "static/img/2.e9895f49.svg";